module.exports = __webpack_public_path__ + "static/coding-a8d5f50a554a9914a77eea79e4cebab9.png";